<template>
  <div class="auth-form-container">
    <div class="auth-form">
      <h2>{{ isLogin ? $t("login.title") : $t("register.title") }}</h2>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="username">{{ $t("login.username") }}</label>
          <input
            type="text"
            id="username"
            v-model="authForm.username"
            :placeholder="!isLogin ? $t('login.usernamePlaceholder') : ''"
            required
          />
          <span v-if="usernameError" class="error-message">{{
            usernameError
          }}</span>
        </div>
        <div class="form-group">
          <label for="password">{{ $t("login.password") }}</label>
          <input
            type="password"
            id="password"
            v-model="authForm.password"
            :placeholder="!isLogin ? $t('login.passwordPlaceholder') : ''"
            required
          />
          <span v-if="passwordError" class="error-message">{{
            passwordError
          }}</span>
        </div>
        <div class="form-group" v-if="!isLogin">
          <label for="confirmPassword">确认密码</label>
          <input
            type="password"
            id="confirmPassword"
            v-model="authForm.confirmPassword"
            :placeholder="!isLogin ? '' : ''"
            required
          />
          <span v-if="passwordError" class="error-message">{{
            passwordError
          }}</span>
        </div>
        <div class="form-group" v-if="!isLogin">
          <label for="email">邮箱</label>
          <div class="email-input-wrapper">
            <input type="text" id="email" v-model="authForm.email" required />
            <button
              type="button"
              @click="sendCaptcha(1)"
              :disabled="isCountdown"
              class="captcha-button"
            >
              {{ countdown > 0 ? `${countdown}s` : "获取验证码" }}
            </button>
          </div>
        </div>
        <div class="form-group" v-if="!isLogin">
          <label for="captcha">验证码</label>
          <input type="text" id="captcha" v-model="authForm.captcha" required />
        </div>
        <button type="submit">
          {{ isLogin ? $t("login.submit") : $t("register.submit") }}
        </button>
      </form>
      <p @click="toggleAuthMode">
        {{ isLogin ? $t("register.switch") : $t("login.switch") }}
      </p>
      <p @click="showPage">忘记密码</p>
    </div>
  </div>
  <el-dialog
    v-model="centerDialogVisible"
    title="忘记密码"
    width="500"
    destroy-on-close
    center
  >
    <div class=""></div>

    <template #footer>
      <el-form :model="form" label-width="auto" style="max-width: 600px">
        <el-form-item label="邮箱：">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="验证码：">
          <div class="email-input-wrapper">
            <input type="text" id="email" v-model="form.code" required />
            <button
              type="button"
              @click="sendCaptcha(2)"
              :disabled="isCountdown2"
              class="captcha-button"
            >
              {{ countdown2 > 0 ? `${countdown2}s` : "获取验证码" }}
            </button>
          </div>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="form.password" type="password" />
        </el-form-item>
        <el-form-item label="确认密码：">
          <el-input v-model="form.confirmPassword" type="password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editPassword">确认</el-button>
        </el-form-item>
      </el-form>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { forgetPassword } from "@/api/user";

export default defineComponent({
  name: "LoginRegister",
  data(): any {
    return {
      isLogin: true,
      authForm: {
        username: "",
        password: "",
        email: "",
        captcha: "",
        confirmPassword: "",
      },
      form: {
        code: "",
        password: "",
        confirmPassword: "",
        email: "",
      },
      countdown: 0,
      countdown2: 0,
      countdownInterval: null,
      countdownInterval2: null,
      usernameError: "",
      passwordError: "",
      centerDialogVisible: false,
    };
  },
  computed: {
    isCountdown() {
      return this.countdown > 0;
    },
    isCountdown2() {
      return this.countdown2 > 0;
    },
  },
  methods: {
    handleSubmit() {
      // if (!this.validateForm()) {
      //   return;
      // }

      if (this.isLogin) {
        this.$store
          .dispatch("user/login", this.authForm)
          .then(() => {
            this.$router.push("/");
          })
          .catch((err: any) => {});
      } else {
        if (this.authForm.password === this.authForm.confirmPassword) {
          this.$store
            .dispatch("user/register", this.authForm)
            .then(() => {
              this.$router.push("/");
            })
            .catch((err: any) => {});
        } else {
          ElMessage.error("密码不一致");
        }
      }
    },
    validateForm() {
      const usernamePattern = /^[a-zA-Z0-9]{6,9}$/;
      const passwordPattern = /^[a-zA-Z0-9]{6,9}$/;

      this.usernameError = "";
      this.passwordError = "";

      if (!usernamePattern.test(this.authForm.username)) {
        this.usernameError = "用户名必须为6到9个非特殊符号的字符";
      }

      if (!passwordPattern.test(this.authForm.password)) {
        this.passwordError = "密码必须为6到9个非特殊符号的字符";
      }

      return !this.usernameError && !this.passwordError;
    },
    toggleAuthMode() {
      this.isLogin = !this.isLogin;
      this.authForm = {
        username: "",
        password: "",
        email: "",
        captcha: "",
      };
    },
    sendCaptcha(options: number) {
      const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;

      if (options == 1) {
        if (!this.authForm.email) {
          ElMessage.error("请输入邮箱地址");
          return;
        }

        if (!reg.test(this.authForm.email)) {
          ElMessage.error("邮箱格式错误");
          return;
        }

        this.$store
          .dispatch("user/GetEmailCode", {
            action: "注册账号",
            userName: this.authForm.email,
          })
          .then((res) => {})
          .catch((err: any) => {});

        this.countdown = 60;
        this.countdownInterval = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown -= 1;
          } else {
            clearInterval(this.countdownInterval);
          }
        }, 1000);
      } else if (options == 2) {
        if (!this.form.email) {
          ElMessage.error("请输入邮箱地址");
          return;
        }

        if (!reg.test(this.form.email)) {
          ElMessage.error("邮箱格式错误");
          return;
        }

        this.$store
          .dispatch("user/GetEmailCode", {
            action: "忘记密码",
            userName: this.form.email,
          })
          .then((res) => {})
          .catch((err: any) => {});

        this.countdown2 = 60;
        this.countdownInterval2 = setInterval(() => {
          if (this.countdown2 > 0) {
            this.countdown2 -= 1;
          } else {
            clearInterval(this.countdownInterval2);
          }
        }, 1000);
      }
    },
    showPage() {
      this.centerDialogVisible = true;
    },
    editPassword() {
      if (this.form.password != this.form.confirmPassword) {
        ElMessage.error({
          message: "两次密码不一致",
        });
        return;
      }

      if (this.form.confirmPassword.length < 6) {
        ElMessage.error({
          message: "密码必须大于6位",
        });
        return;
      }

      this.$store
        .dispatch("user/forgetPassword", {
          code: this.form.code,
          email: this.form.email,
          newPassword: this.form.confirmPassword,
        })
        .then((res) => {
          this.centerDialogVisible = false;
        })
        .catch((err: any) => {});
    },
  },

  beforeUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
});
</script>

<style scoped>
.auth-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.auth-form {
  width: 100%;
  max-width: 400px;
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 1em;
}

label {
  display: block;
  margin-bottom: 0.5em;
}

input {
  width: 100%;
  padding: 0.5em;
  box-sizing: border-box;
}

.email-input-wrapper {
  display: flex;
  align-items: center;
}

.captcha-button {
  margin-left: 10px;
  padding: 0.5em;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.captcha-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

button {
  width: 100%;
  padding: 0.7em;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

p {
  text-align: center;
  margin-top: 1em;
  cursor: pointer;
  color: #007bff;
}

p:hover {
  text-decoration: underline;
}

.error-message {
  color: red;
  font-size: 0.8em;
}
</style>
